<template>
  <v-card flat id="headerBar">
    <v-toolbar style="height: 64px !important" color="primary" dark flat>
      <v-btn icon v-if="(showBackButton() || $route.name === 'menu-selection') && $route.name !== '404'" @click="$route.name !== 'store' ? onStoreLogoClick() : null" :disabled="$route.name === 'store'" style="height: 64px; width: 64px; display: inline-flex; align-items: center; justify-content: center;">
        <!-- v-btn icon's default sizing clips content well below the image's own
             max-height, which is why this rendered smaller than reservation's shared
             header despite an identical max-height value. This button + img pair is
             now a literal structural mirror of reservation's .hdr-logo-btn/.hdr-logo-img
             (header.component.css): same explicit container size + centering, same
             explicit image height (not Vuetify's max-height prop) -- both headers
             resolve the logo's size and position via the exact same CSS, not just
             the same numbers, so there's no gap left for the two to drift apart. -->
        <img
          :src="getLogoImage"
          alt="Store Logo"
          style="height: 36px; width: auto; max-width: 64px; object-fit: contain; display: block;"
        />
      </v-btn>
      <v-btn icon v-if="showBackButton() && (shouldShowBackButtonForStore || $route.name !== 'store') && $route.name !== '404'" @click="onBackButtonClick()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-btn flat v-if="$route.name === 'menu-selection' && !isMobile && $route.name !== '404'" @click="onGroupButtonClick()" class="externalAppsButton">
        <div style="display: inline-block; margin-right: auto;">
          <span>{{ $vuetify.t('$vuetify.common.location') }}</span>
        </div>
      </v-btn>
      <v-btn flat v-if="showLocations && showBackButton() && !isMobile && $route.name !== '404'" @click="onGroupButtonClick()" class="externalAppsButton">
        <div v-if="($route.name === 'menu-selection' || ($route.name === 'store'))" style="display: inline-block; margin-right: auto;">
          <span>{{ $vuetify.t('$vuetify.common.location') }}</span>
        </div>
      </v-btn>
      <v-btn
        icon
        v-if="isMobile && hasExternalApps && groupSettings && groupSettings.owaSettings && 
            groupSettings.owaSettings.externalSettings && groupSettings.owaSettings.externalSettings.topBannerExternalLinks &&
            $route.name !== 'group' && $route.name !=='checkout' && $route.name !== '404'"
        @click="toggleCombinedDrawer"
        :style="!$route.params.sid ? 'margin-left: auto;' : ''"
      >
        <v-icon>menu</v-icon>
      </v-btn>
      <v-btn 
        icon 
        v-else-if="isMobile && hasExternalApps && $route.name !== 'group' && $route.name !=='checkout' && $route.name !== '404'"
        @click="toggleExternalDrawer"
        class="mr-2"
      >
        <v-icon>menu</v-icon>
      </v-btn>
      <!-- Hiding this based on the ticket DEV-4636 -->
      <!-- <v-btn
        icon
        v-else-if="isMobile && groupSettings && groupSettings.owaSettings && 
                  groupSettings.owaSettings.externalSettings && groupSettings.owaSettings.externalSettings.topBannerExternalLinks"
        @click="toggleDrawer"
        :style="!$route.params.sid ? 'margin-left: auto;' : ''"
      >
        <v-icon>menu</v-icon>
      </v-btn> -->
      <!-- <div v-if="getLogoImage && isMobile && getLogoImage && $route.params.gid && !$route.params.sid">
        <v-btn
          flat
          target="_blank"
          :href="storeLogoLink"
          @click="handleClickStoreLogo"
          class="white--text"
          style="display: flex; justify-content: flex-start; align-items: center; padding: 0; height: 50px; min-width: 50px;"
        >
          <v-img
            :src="getLogoImage"
            alt="Store Logo"
            max-height="50"
            max-width="50"
            style="display: inline-block;"
          ></v-img>
        </v-btn>
      </div> -->
      <div v-if="$route.name !== 'group' && $route.name !=='checkout' && $route.name !== '404' && groupSettings && groupSettings.owaSettings && groupSettings.owaSettings.externalSettings && groupSettings.owaSettings.externalSettings.topBannerExternalLinks">
        <v-toolbar-items v-if="!isMobile">
          <template v-for="(link, index) in groupSettings.owaSettings.externalSettings.topBannerExternalLinks">
            <v-btn
              v-if="link.label === 'STORE_LOGO' && getLogoImage"
              flat
              target="_blank"
              :href="link.link"
              class="white--text"
              style="height: 64px;"
            >
              <span>HOME</span>
            </v-btn>
            <v-btn
              v-else-if="link.label !== 'STORE_LOGO'"
              flat
              target="_blank"
              :href="link.link"
              class="white--text"
              style="height: 64px;"
            >
              <span>{{ link.label }}</span>
            </v-btn>
          </template>
        </v-toolbar-items>
      </div>
      <!-- Order -- OWA is itself the ordering app, so this is a non-clickable
           "you are here" label, same convention as reservation's own header
           (.hdr-btn-active: bold, no link) when reservation is the active page. -->
      <span
        v-if="!isMobile && correctRoute && $route.name !== '404'"
        class="externalAppsButton externalAppsButtonActive"
        :style="!$route.params.sid ? 'margin-left: auto;' : ''"
        aria-current="page"
      >{{ $vuetify.t('$vuetify.common.order') }}</span>
      <v-btn
        flat
        v-if="!isMobile && allowReservation && correctRoute && $route.name !== '404'"
        @click="goToExternalApp('reservation')"
        class="externalAppsButton"
      >
      <span>{{ $vuetify.t('$vuetify.apps.reservation') }}</span>
    </v-btn>
      <v-btn
        flat
        v-if="!isMobile && allowLineup && correctRoute && $route.name !== '404'"
        @click="goToExternalApp('lineup')"
        class="externalAppsButton"
      >
      <span>{{ $vuetify.t('$vuetify.apps.lineup') }}</span>
    </v-btn>
      <v-btn
        flat
        v-if="!isMobile && allowGiftCard && correctRoute && $route.name !== '404'"
        @click="goToExternalApp('giftcard')"
        class="externalAppsButton"
      >
      <span>{{ $vuetify.t('$vuetify.apps.giftcard') }}</span>
      </v-btn>
      <v-btn
        flat
        v-if="!isMobile && allowDeposit && correctRoute && $route.name !== '404'"
        @click="goToExternalApp('deposit')"
        class="externalAppsButton"
      ><span>{{ $vuetify.t('$vuetify.apps.deposit') }}</span></v-btn>
      <v-spacer v-if="!isMobile || $route.params.sid"></v-spacer>
      <v-toolbar-items>
        <template v-if="!_isNullOrEmpty(getStoreLanguages) && getStoreLanguages.length > 1 && $route.name != 'group'">
          <v-menu offset-y
            :position-x="menuX"
            :position-y="menuY"
            v-model="showMenu"
            :close-on-content-click="true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn flat v-bind="attrs" v-on="on" style="height: 64px;">
                <v-icon>language</v-icon>
                <span style="margin-left: 5px" v-if="!isMobile">
                {{ getStoreLanguages.find(lang => langIsSelected(lang)) 
                  ? ({ en: 'English', zh: '中文', 'zh-TW': '繁體中文', fr: 'Français', ko: '한국어', th: 'ไทย', ar: 'العربية', vi: 'Tiếng Việt'  }[
                      getStoreLanguages.find(lang => langIsSelected(lang)).code
                    ] || '')
                  : 'Select Language' }}
                </span>
                <!-- <v-icon right>arrow_drop_down</v-icon> -->
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="lang in getStoreLanguages"
                :key="lang.code"
                @click="changeLang(lang.code)"
                :class="{ 'active-lang': langIsSelected(lang) }"
                style="display: block; width: 100%;"
                class="language-item"
              >
                <v-list-item-title>
                  <template v-if="lang.code === 'en'">English</template>
                  <template v-else-if="lang.code === 'zh'">中文</template>
                  <template v-else-if="lang.code === 'zh-TW'">繁體中文</template>
                  <template v-else-if="lang.code === 'fr'">Français</template>
                  <template v-else-if="lang.code === 'es'">Español</template>
                  <template v-else-if="lang.code === 'ko'">한국어</template>
                  <template v-else-if="lang.code === 'vi'">Tiếng Việt</template>
                  <template v-else-if="lang.code === 'th'">ไทย</template>
                  <template v-else-if="lang.code === 'ar'">العربية</template>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-if="group && groupPageLanguages.length > 1 && $route.name == 'group'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn flat v-bind="attrs" v-on="on" style="height: 64px;">
                <v-icon>language</v-icon>
                <span style="margin-left: 5px" v-if="!isMobile">
                  {{ ({ en: 'English', zh: '中文', 'zh-TW': '繁體中文', fr: 'Français', es: 'Español', ko: '한국어', th: 'ไทย', ar: 'العربية', vi: 'Tiếng Việt' })[({'zhHans':'zh','zhTW':'zh-TW'})[$vuetify.lang.current] || $vuetify.lang.current] || 'English' }}
                </span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="lang in groupPageLanguages"
                :key="lang.code"
                @click="changeLang(lang.code)"
                :class="{ 'active-lang': langIsSelected(lang) }"
                style="display: block; width: 100%;"
                class="language-item"
              >
                <v-list-item-title>{{ lang.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <v-btn icon v-if="!getExistingOrder.length && isDineIn && !inFastServiceDineIn && $route.name !== 'group' && $route.name !== '404'" @click="setQrScanner(true)">
          <v-icon>photo_camera</v-icon>
        </v-btn>

        <template v-if="$route.name !== 'group' && $route.name !== 'checkout' && $route.name !== '404'">
          <header-bar-menu v-if="isLoggedIn" />
          <v-icon style="padding-right: 16px" v-else-if="allowsGuest" @click="goToGuestHistory">list_alt</v-icon>
          <v-btn flat v-on="on" v-if="!isLoggedIn && !isMobile && !$store.getters['groupOrder/isGuestParticipant']" @click="openLogin">
            <v-icon>account_circle</v-icon>
            <span style="margin-left: 5px">{{ $vuetify.t('$vuetify.common.login') }}</span>
          </v-btn>
          <v-btn icon v-on="on" v-if="!isLoggedIn && isMobile && !$store.getters['groupOrder/isGuestParticipant']" @click="openLogin">
            <v-icon>account_circle</v-icon>
          </v-btn>
          <v-btn flat v-if="$vuetify.breakpoint.mdAndUp" @click="toggleCart">
            <v-badge
            color="white"
            overlap
            >
            <span slot="badge" v-if="getNumCartItems > 0" class="badge-text">{{ getNumCartItems }}</span>
              <v-icon>shopping_cart</v-icon>
            </v-badge>
            <span v-if="!isMobile" style="margin-left: 3px">{{ $vuetify.t('$vuetify.cart.title') }}</span>
          </v-btn>
          <div v-else @click="toggleCart" :class="{ 'cart-error': cartContainsError }" class="mobile-cart-container">
            <v-badge
            color="white"
            overlap
            >
            <span v-if="getNumCartItems > 0" slot="badge" class="badge-text">{{ getNumCartItems }}</span>
              <v-icon>shopping_cart</v-icon>
            </v-badge>
            <span v-if="!isMobile" style="margin-left: 3px">{{ $vuetify.t('$vuetify.cart.title') }}</span>
            <!-- <div id="cartSize">
              {{ getNumCartItems }}
            </div> -->
          </div>
        </template>
      </v-toolbar-items>
      <v-navigation-drawer
        v-model="externalDrawer"
        app
        temporary
        left
        width="100%"
        style="top: 0 !important; margin-top: 0 !important; height: 100vh !important; width: 100vw !important; max-width: 100vw !important;"
        class="external-apps-drawer"
      >
        <v-list style="display:flex; flex-direction: column; padding-top: 75px">
          <v-list-item style="text-align: left">
            <v-btn icon @click="externalDrawer = false" class="close-btn-left">
              <v-icon style="font-size: 24px !important">close</v-icon>
            </v-btn>
          </v-list-item>
          
          <!-- Include top banner links when in combined mode -->
          <template v-if="groupSettings && groupSettings.owaSettings && groupSettings.owaSettings.externalSettings && groupSettings.owaSettings.externalSettings.topBannerExternalLinks">
            <v-list-item
              v-for="(link, index) in groupSettings.owaSettings.externalSettings.topBannerExternalLinks"
              :key="'banner-' + index"
              class='mobile-list-item'
            >
              <v-btn
                flat
                target="_blank"
                :href="link.link"
                class="white--text"
                style="width: 100%; "
                v-if="link.label !== 'STORE_LOGO'"
              >
                <div style="text-align: left; width: 100%;">
                  <strong>{{ link.label }}</strong>
                </div>
              </v-btn>
              <v-btn
                flat
                target="_blank"
                :href="link.link"
                class="white--text"
                style="width: 100%;"
                v-else-if="link.label === 'STORE_LOGO'"
              >
                <div style="text-align: left; width: 100%; ">
                  <strong>HOME</strong>
                </div>
              </v-btn>
            </v-list-item>
          </template>
          
          <!-- External Apps - Always with buttons and text -->
          <v-list-item class='mobile-list-item' v-if="showLocations">
            <v-btn flat @click="goToExternalApp('homepage')" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.common.location') }}</strong>
              </div>
            </v-btn>
          </v-list-item>
          <!-- Order -- non-clickable "you are here" row, same as the desktop
               nav's Order label and reservation's own drawer-item-current.
               Uses the same v-btn wrapper as every other row (no @click) so
               it inherits v-btn's bold/uppercase styling instead of a bare
               <strong> falling back to the browser's thin default weight. -->
          <v-list-item class='mobile-list-item'>
            <v-btn flat disabled class="white--text order-label-btn" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.common.order') }}</strong>
              </div>
            </v-btn>
          </v-list-item>
          <v-list-item class='mobile-list-item' v-if="allowReservation">
            <v-btn flat @click="goToExternalApp('reservation')" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.apps.reservation') }}</strong>
              </div>
            </v-btn>
          </v-list-item>

          <v-list-item class='mobile-list-item' v-if="allowLineup">
            <v-btn flat @click="goToExternalApp('lineup')" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.apps.lineup') }}</strong>
              </div>
            </v-btn>
          </v-list-item>

          <v-list-item class='mobile-list-item' v-if="allowGiftCard">
            <v-btn flat @click="goToExternalApp('giftcard')" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.apps.giftcard') }}</strong>
              </div>
            </v-btn>
          </v-list-item>

          <v-list-item class='mobile-list-item' v-if="allowDeposit">
            <v-btn flat @click="goToExternalApp('deposit')" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.apps.deposit') }}</strong>
              </div>
            </v-btn>
          </v-list-item>

          <!-- Login/Sign Up -- reservation's shared header drawer has this same row
               (Login when logged out); OWA's drawer was missing it entirely. Same
               gate as the toolbar's own login button above (!isLoggedIn, not a guest
               participant) so this never shows alongside header-bar-menu's own
               logged-in account menu. -->
          <v-list-item class='mobile-list-item' v-if="!isLoggedIn && !$store.getters['groupOrder/isGuestParticipant']">
            <v-btn flat @click="externalDrawer = false; openLogin()" class="white--text" style="width: 100%;">
              <div style="text-align: left; width: 100%;">
                <strong>{{ $vuetify.t('$vuetify.common.login') }}</strong>
              </div>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-toolbar>

    <v-dialog v-model="cartDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :width="$vuetify.breakpoint.mdAndUp ? 450 : '100%'"
      content-class="rounded-dialog cartDialogClass"
    >
      <v-card class="rounded-card">
          <div class="header-container">
          <h2 class="title-text">
            {{  getStore.name }}
          </h2>
        <v-btn
          icon
          class="close-btn"
          @click="cartDialog = false"
        >
          <i class="v-icon material-icons">close</i>
        </v-btn>
      </div>
        <!-- <v-toolbar style="height: 64px;" dark color="primary">
          <v-toolbar-title class="white--text">
            Cart
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn flat text id="closeButton" @click="cartDialog = false">
            {{ $vuetify.t('$vuetify.cart.closeModal') }}
          </v-btn>
        </v-toolbar> -->

        <cart ref="cartComponent" @closeCart="cartDialog = false" />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  import get from 'lodash/get';

  import { mapGetters, mapMutations, mapActions } from 'vuex'

  import Cart from '@/components/Cart.vue'
  import HeaderBarMenu from '@/components/HeaderBarMenu.vue'
  import StoreSubHeader from '@/components/StoreSubHeader.vue'
  import GroupSubHeader from '@/components/GroupSubHeader.vue'
  import OrderTypeSelect from '@/components/OrderTypeSelect.vue'
  import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
  import { isNullOrEmpty, disableDocumentScrolling, enableDocumentScrolling } from '../services/util.service'
  import { isInSchedule } from '../services/schedule.service'

  export default {
    components: {
      Cart,
      StoreSubHeader,
      GroupSubHeader,
      HeaderBarMenu,
      VuetifyGoogleAutocomplete,
      OrderTypeSelect
    },

    data() {
      return {
        cartDialog: false,
        scrollTop: null,

        waitForTable: false,
        backButtonMap: {
          "checkout": 'store',
          "menu-selection": 'group',
          "store": 'group',
          'store-account': 'store',
          'wechat-handler': 'store',
          'guest-history': 'store'
        },
        groupLang: [],
        group: false,
        externalDrawer: false,
        showMenu: false,
        menuX: 0,
        menuY: 0,
        showLocations: false
      }
    },
    mounted() {
      let sid = this.$route.params.sid || get(this.getStore, "storeId", null);
      if (sid && (!this.filteredMenus.length || !this.hasMultipleMenus)) {
        this.fetchLiteMenus();
      }
      this.$bus.$on('guestCheckoutSuccess', () => {
        this.cartDialog = false;
      });
      this.$bus.$on('toggleCart', (open) => {
        if (open === true || open === undefined) {
          this.cartDialog = true;
        } else {
          this.cartDialog = false;
        }
      });
    },
    beforeDestroy() {
      this.$bus.$off('guestCheckoutSuccess');
    },
    computed: {
      correctRoute() {
        return this.$route.name !== 'group' && this.$route.name !=='checkout' && this.$route.name !== '404'
      },
      hasExternalApps() {
        return this.allowGiftCard || 
              this.allowReservation || 
              this.allowDeposit || 
              this.allowLineup
      },
      customer() {
        return this.getCustomer || {}
      },
      allowGiftCard() {
        return get(this.getStore, 'features.selfcareGiftcardSupported', false)
      },
      allowDeposit() {
        return get(this.getStore, 'features.selfcareMembershipDepositSupported', false)
      },
      allowLineup() {
        return !get(this.getStore, 'settings.owaSettings.hideLineup', false)
          && get(this.getStore, 'features.webLineupSupported', false)
          && get(this.getStore, 'settings.webLineupSettings.webLineupEnabled', false)
          && get(this.getStore, 'features.inStoreLineupSupported', false)
      },
      allowReservation() {
        return get(this.getStore, 'features.cpReservationSupported', false)
          && get(this.getStore, 'features.inStoreReservationSupported', false)
          && get(this.getStore, 'settings.webReservationSettings.webReservationEnabled', false)
      },
      filteredMenus() {
        try {
          if (this.getAvailableMenus && this.getAvailableMenus.length && this.getLiteMenus && this.getLiteMenus.length) {
            let shouldCheckSchedule = false;
            if (!this.getCheckoutInfo || (!this.getCheckoutInfo.scheduledDay && !this.getCheckoutInfo.scheduledTime)) {
              shouldCheckSchedule = false 
            } else {
              shouldCheckSchedule = true
            }
            const filteredMenus = this.getAvailableMenus.filter(menu => {
                if (menu.schedule && shouldCheckSchedule) {
                  const isAvailable = this.isMenuAvailable(menu);
                  if (!isAvailable) {
                    return false;
                  }
                }
              if(menu.channels && menu.channels.length) {
                return menu.channels.includes("ONLINE") && this.getLiteMenus.some(liteMenu => liteMenu.code === menu.code);
              } else {
                return this.getLiteMenus.some(liteMenu => liteMenu.code === menu.code)
              }
            });
            if (filteredMenus.length == 0){
              return this.getLiteMenus.map(liteMenu => {
                return {
                  ...liteMenu,
                  unavailable: true
                }
              })
            }
            return filteredMenus;
          } else {
            return [];
          }
        } catch (e) {
          return [];
        }
      },
      storeLogoLink() { 
        if (this.groupSettings && this.groupSettings.owaSettings && this.groupSettings.owaSettings.externalSettings && this.groupSettings.owaSettings.externalSettings.topBannerExternalLinks) {
          const links = this.groupSettings.owaSettings.externalSettings.topBannerExternalLinks;
          const storeLogo = links.find(link => link.label === 'STORE_LOGO');
          return storeLogo ? storeLogo.link : ''; 
        }
        return '';
      },
      isMobile() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return this.$vuetify.breakpoint.smAndDown || /mobile|android|iphone|ipad|ipod/.test(userAgent)
      },
      getLogoImage() {
        const path = process.env.VUE_APP_API_IMAGE
        let relativePath = get(this.getStore, 'images.OWA_LOGO[0].url') || get(this.getStore, 'images.LOGO[0].url')
        if (!relativePath) {
          relativePath = get(this.getGroup, 'storeLogo')
        }

        if (relativePath) {
          return `${path}${relativePath}`
        } else {
          return ''
        }
      },
      groupSettings() {
        return get(this.getGroup, 'settings', {})
      },
      groupPageLanguages() {
        // Use groupLang if it has multiple entries (from groupNameTranslation)
        if (this.groupLang && this.groupLang.length > 1) return this.groupLang
        // Fall back to languages derived from group stores (from /owa/store?groupId= response)
        const hardCodedLangs = [
          { code: 'en', name: 'English' },
          { code: 'fr', name: 'Français' },
          { code: 'zh', name: '中文' },
          { code: 'zh-TW', name: '繁體中文' },
          { code: 'ko', name: '한국어' },
          { code: 'th', name: 'ไทย' },
          { code: 'ar', name: 'العربية' },
          { code: 'vi', name: 'Tiếng Việt' },
          { code: 'es', name: 'Español' }
        ]
        const stores = this.getGroupStores || []
        const langSet = new Set()
        stores.forEach(store => {
          const langs = get(store, 'settings.orderSettings.displayLanguages') || get(store, 'settings.owaSettings.displayLanguages') || get(store, 'languages', [])
          langs.forEach(l => langSet.add(typeof l === 'string' ? l : l.code))
        })
        if (langSet.size > 1) {
          return hardCodedLangs.filter(l => langSet.has(l.code))
        }
        // Use getStoreLanguages if a store is loaded (e.g. navigating back from store page)
        if (this.getStoreLanguages && this.getStoreLanguages.length > 1) return this.getStoreLanguages
        return []
      },
      allowsGuest() {
        return !this.isLoggedIn && this.allowAnonymousDineIn && this.skipCheckout === true
      },

      cartContainsError() {
        return !!this.cartErrorMessage
      },

      shouldShowBackButtonForStore() {
        if (this.$route.name === 'store') {
          const hasStoreId = this.$route.params.sid || get(this.getStore, "storeId", null);
          const menusNotLoaded = !this.filteredMenus.length && hasStoreId;
          const hasMultiple = this.hasMultipleMenus && this.filteredMenus.length > 1;
          
          return hasMultiple || menusNotLoaded;
        }
        return true;
      },

      orderTypeName() {
        const i18nString = get(this.getOrderTypeObject, 'i18n', '')
        return this.$vuetify.t(i18nString)
      },

      ...mapGetters([
        'getMenu',
        'getAuthToken',
        'getAvailableMenus',
        'getLiteMenus',
        'getStore',
        'getGroup',
        'getCustomer',
        'getCustomerRewards',
        'getServerCart',
        'isDineInTableSet',
        'friendlyAlertsCount',
        'isLoggedIn',
        'getNumCartItems',
        'isDineIn',
        'inFastServiceDineIn',
        'getOrderTypeObject',
        'getExistingOrder',
        'langIsSelected',
        'getStoreLanguages',
        'doesGroupHaveMultipleStores',
        'hasMultipleMenus',
        'skipCheckout',
        'getQrScannerDialog',
        'allowAnonymousDineIn',
        'cartErrorMessage',
        'getCheckoutInfo',
        'getGroupStores'
      ])
    },

    watch: {
      // DEV-11458: the cart is an overlay on the current page, so leaving the page -- the
      // browser's back/forward buttons included -- closes it, rather than leaving it open on
      // the next page (e.g. over checkout). Path only: query-only URL updates keep it open.
      '$route.path'() {
        this.cartDialog = false
      },
      getGroup: {
        handler(val) {
          if (val && val && Object.keys(val).length > 0) {
            if (val.stores && val.stores.length && val.stores.length > 1) {
              this.showLocations = true
            } else {
              this.showLocations = false
            }
            if (val.groupNameTranslation && val.groupNameTranslation.translations && val.groupNameTranslation.translations.length > 0) {
              const groupNames = val.groupNameTranslation.translations;

              const hardCodedLangs = [
          { code: "en", name: "English" },
          { code: "fr", name: "Francais" },
          { code: "zh", name: "中文" },
          { code: "zh-TW", name: "繁體中文" },
          { code: "ko", name: "한국어" },
          { code: "th", name: "ไทย" },
          { code: "ar", name: "العربية" },
          { code: "vi", name: "Tiếng Việt" }
        ];
              const extractedLangs = groupNames.map(item => item.lang);
              const filteredLangs = hardCodedLangs.filter(lang => extractedLangs.includes(lang.code));
              this.groupLang = filteredLangs
              // Only fall back to the group's own language default when the store itself
              // has no language preference set (no explicit user selection, and no store-level
              // languages[].selected already applied by determineInitialLang). Otherwise this
              // watcher would stomp a correctly-resolved store-level default on every store load.
              const userHasManuallySelected = localStorage.getItem('langManuallySelected') === 'true'
              const storeHasSelectedLang = (this.getStoreLanguages || []).some(lang => lang.selected)
              if (val.languages && !userHasManuallySelected && !storeHasSelectedLang) {
                const selectedDefault = val.languages.find(lang => lang.selected);
                if (selectedDefault) {
                  this.changeLang(selectedDefault.code)
                }
              }
            }
            this.group = true;
          } else {
            this.showLocations = false
          }
        },
        immediate: true
      },
      getQrScannerDialog() {
        // Call server option requires a table number. If the user clicked the button but does not have a table,
        // we set waitForTable and listen for the scanner dialog to be closed to see if it was set
        // Upon close, if they now have a table number, automatically open the request service dialog
        if (this.waitForTable && !this.getQrScannerDialog) {
          // Regardless of result, the dialog was closed and we are done waiting
          this.waitForTable = false

          // Since this is the last requirement checked, we only need to check for a table number now
          if (this.isDineInTableSet) {
            // this.SET_CALL_SERVER_DIALOG(true)
          }
        }
      },

      cartDialog() {
        if (this.cartDialog) {
          this.$store.dispatch('fetchAiCartRecommendationsOnOpen')
          this.$store.dispatch('trackCartEvent', { event: 'view_cart' })
        }

        // Disable scrolling the page on mobile to fix background scrolling bug
        if (this.$vuetify.breakpoint.smAndDown) {
          if (this.cartDialog) {
            this.scrollTop = document.getElementsByTagName("body")[0].scrollTop || document.getElementsByTagName("html")[0].scrollTop || document.getElementById("app").scrollTop

            setTimeout(() => {
              disableDocumentScrolling(this.scrollTop)
            }, 300)
          } else {
            enableDocumentScrolling(this.scrollTop)
            this.scrollTop = null
          }
        }

        // v-dialog keeps its content mounted when closed (no destroy/recreate), so any
        // confirm dialog left open inside Cart (e.g. "Is everyone ready?") would otherwise
        // reappear stale the next time the cart is opened.
        if (!this.cartDialog && this.$refs.cartComponent) {
          this.$refs.cartComponent.resetTransientDialogs()
        }
      }
    },

    methods: {
      isMenuAvailable(menu) {
        const scheduledDate = this.getCheckoutInfo.scheduledDay;
        const scheduledTime = this.getCheckoutInfo.scheduledTime;
        if (!menu.schedule || !menu.schedule.items || menu.schedule.items.length === 0) {
          return true; 
        }

        if (scheduledTime == 'now') {
          const storeTimeZone = this.getStore.timeZone || "America/Toronto";
          const now = new Date(
            new Date().toLocaleString("en-US", { timeZone: storeTimeZone })
          );
          return isInSchedule(menu.schedule.items, now, 0);
        }
        const targetDate = new Date(scheduledDate);
        const targetTime = new Date(scheduledTime);

        const targetDay = targetDate.toLocaleString('en-US', { weekday: 'long' }).toUpperCase();
        const targetHour = targetTime.getHours() + targetTime.getMinutes() / 60;

        return menu.schedule.items.some(schedule => {
          if (schedule.type === 'DAYS_OF_WEEK' && schedule.days.includes(targetDay)) {
            return schedule.timeRange.some(range => {
              return targetHour >= range.start && targetHour <= range.end;
            });
          }
          return false;
        });
      },
      toggleCombinedDrawer() {
        const wasOpen = this.externalDrawer;
        this.externalDrawer = !wasOpen;
      },
      updateMenuPosition(event) {
        const button = event.target.closest('.v-btn');
        if (!button) return;
        
        const rect = button.getBoundingClientRect();
        this.menuX = rect.x;
        this.menuY = rect.y + rect.height;
        this.showMenu = true;
      },
      toggleExternalDrawer() {
        this.externalDrawer = !this.externalDrawer
      },
      openLogin() {
        this.setLoginDialog(true)
      },
      goToExternalApp(appType) {
        let url;
        switch(appType) {
          case 'giftcard':
          case 'deposit':
            url = this.buildGiftCardAppsUrl(appType === 'giftcard' ? 'GiftCard' : 'Deposit');
            break;
          case 'lineup':
          case 'reservation':
            url = this.buildAngularAppsUrl(appType);
            break;
          case 'homepage': 
              this.$router.push({ name: 'group', params: {groupSlug: this.getGroup.slug, gid: this.getStore.groupId}, query: this.$route.query }).catch(() => {})
            return;
        }
        if (url) window.location.href = url;
      },

      buildGiftCardAppsUrl(route) {
        const storeId = get(this.getStore, 'settings.rewardsSettings.selfcareGiftcardSharedStoreId', this.getStore.storeId);
        let url = `${process.env.VUE_APP_APP_BASE}/giftcard/${storeId}`;
        url += `?feature=${route}`;
        url += `&returnUrl=${window.location.href}`;
        url += this.addUserDetails('11111');
        return url;
      },

      buildAngularAppsUrl(route) {
        let url = `${process.env.VUE_APP_APP_BASE}/${route}/`;
        url += `?storeId=${this.getStore.storeId}`;
        if (route === 'lineup') {
          url += '&force=true&noSms=true';
        }
        url += this.addUserDetails('11001');
        url += `&returnUrl=${window.location.href}`;
        return url;
      },

      addUserDetails(paramFlags) {
        let string = '';
        if (this.isLoggedIn) {
          string += paramFlags[0] == 1 ? `&name=${this.customer.firstName} ${this.customer.lastName}` : '';
          string += paramFlags[1] == 1 ? `&telephone=${this.customer.telephone}` : '';
          string += paramFlags[2] == 1 ? `&email=${this.customer.email}` : '';
          string += paramFlags[3] == 1 ? `&authorizationId=${this.getAuthToken}` : '';
          string += paramFlags[4] == 1 && this.$vuetify.lang.current != 'fr'
            ? `&lang=${this.$vuetify.lang.current == 'zhHans' ? 'zh' : this.$vuetify.lang.current}`
            : '';
        } else if (paramFlags[3] == 1) {
          string += `&authorizationId=${null}`;
          string += paramFlags[4] == 1 && this.$vuetify.lang.current != 'fr'
            ? `&lang=${this.$vuetify.lang.current == 'zhHans' ? 'zh' : this.$vuetify.lang.current}`
            : '';
        }
        return string;
      },
      handleClickStoreLogo(){
        if (!this.storeLogoLink) {
          event.preventDefault();
        }
      },
      _isNullOrEmpty(list) {
        return isNullOrEmpty(list)
      },

      toggleCart() {
        this.cartDialog = !this.cartDialog
      },

      async onStoreLogoClick() {
        const { name, query } = this.$route
        const dineInOnlyQueryParam = query.dineInOnly;
        const tidQueryParam = query.tid;
        let destinationName = 'store';
        const preservedQuery = { ...query };
        if (dineInOnlyQueryParam) preservedQuery.dineInOnly = dineInOnlyQueryParam;
        if (tidQueryParam) preservedQuery.tid = tidQueryParam;
        const hasScheduledTime = this.getCheckoutInfo && (this.getCheckoutInfo.scheduledTime || this.getCheckoutInfo.scheduledDay);
        if (this.$route.name === 'store' && hasScheduledTime) {
          const sid = this.$route.params.sid || this.getStore.storeId;
          const slug = this.getStore.slug;
          this.$router.push({
            name: 'menu-selection',
            query: preservedQuery,
            params: { restaurantSlug: slug || '', sid }
          }).catch(() => {});
          return;
        }

        if (!this.showLocations && (this.$route.name !== 'store' || this.filteredMenus.length == 1)) {
          destinationName = 'store';
          this.$router.push({ name: destinationName, params: {groupSlug: this.getGroup.slug, gid: this.getStore.groupId}, query: preservedQuery }).catch(() => {})
          return;
        }
        if (this.showBackButton()) {
          if(this.$route.name === 'checkout' || this.$route.name === 'store-account' || this.$route.name === 'guest-history') {
            this.$router.back();
          } else {
              destinationName = this.backButtonMap[name]
            if (name === 'store') {
              return;
            }
            if (destinationName == 'group') {
              if (dineInOnlyQueryParam) {
                destinationName = 'store';
              } else {
                this.$router.push({ name: destinationName, params: {groupSlug: this.getGroup.slug, gid: this.getStore.groupId}, query: preservedQuery }).catch(() => {})
              }
            } else {
              const slug = this.getStore.slug
              this.$router.push({ name: destinationName, query: preservedQuery, params: { restaurantSlug: slug || '' } }).catch(() => {})
            }
          }
        }
      },
      onGroupButtonClick() {
        const { name, query } = this.$route
        this.$router.push({ name: 'group', query, params: { groupSlug: this.getGroup.slug, gid: this.getStore.groupId } }).catch(() => {})
      },
      async onBackButtonClick() {
        const { name, query } = this.$route;
        const dineInOnlyQueryParam = query.dineInOnly;
        const tidQueryParam = query.tid;
        let destinationName = 'store';
        const preservedQuery = { ...query };
        if (dineInOnlyQueryParam) preservedQuery.dineInOnly = dineInOnlyQueryParam;
        if (tidQueryParam) preservedQuery.tid = tidQueryParam;

if (this.$route.name !== 'checkout' && !this.showLocations && ((this.$route.name !== 'store' && this.$route.name !== 'guest-history') || this.filteredMenus.length == 1)) {
          const sid = this.$route.params.sid || this.getStore.storeId;
          this.$router.push({ name: destinationName, params: {groupSlug: this.getGroup.slug || '-', gid: this.getStore.groupId, sid}, query: preservedQuery }).catch(() => {});
          return;
        }
        if (this.$route.name === 'menu-selection') {
          destinationName = 'group';
          const slug = this.getStore.slug;
          this.$router.push({ name: destinationName, query: preservedQuery, params: { groupSlug: this.getGroup.slug, gid: this.getStore.groupId, restaurantSlug: slug || '' } }).catch(() => {});
        } else {
          if (this.showBackButton()) {
            if(this.$route.name === 'guest-history') {
              const slug = this.getStore.slug || 'snappy';
              const sid = this.getStore.storeId;
              const gid = this.getStore.groupId;
              const mid = (this.getMenu && this.getMenu.code) ? this.getMenu.code : undefined;
              const params = { restaurantSlug: slug || '' };
              if (sid) params.sid = sid;
              if (gid) params.gid = gid;
              if (mid) params.mid = mid;
              destinationName = 'store';
              this.$router.push({ name: destinationName, query: preservedQuery, params }).catch(() => {});
            } else if (this.$route.name === 'checkout') {
              // If in a group order, prefer the saved back path but fall through to
              // the normal store-route logic below if it's missing (e.g. after a page reload)
              if (this.$store.getters['groupOrder/isInGroupOrder']) {
                // Try saved back path first
                const savedPath = sessionStorage.getItem('groupOrderCheckoutBackPath');
                sessionStorage.removeItem('groupOrderCheckoutBackPath');
                if (savedPath) {
                  this.$router.push(savedPath).catch(() => {});
                  return;
                }

                // Reconstruct store+menu route from group order state
                const goState = this.$store.state.groupOrder;
                const gid = this.$route.params.gid || (this.getStore && this.getStore.groupId);
                const sid = this.$route.params.sid || (this.getStore && this.getStore.storeId);

                // Extract menu code from participant cart item codes (e.g. "menu_293_categories_...")
                const participantCart = goState && goState.participantCart;
                const firstItemCode = participantCart &&
                  participantCart.subOrderList &&
                  participantCart.subOrderList[0] &&
                  participantCart.subOrderList[0].orderItemList &&
                  participantCart.subOrderList[0].orderItemList[0] &&
                  participantCart.subOrderList[0].orderItemList[0].code;
                const menuMatch = firstItemCode && firstItemCode.match(/^(menu_\d+)/);
                const mid = (menuMatch && menuMatch[1]) ||
                  (this.getAvailableMenus && this.getAvailableMenus.length && this.getAvailableMenus[0].code);

                const slug = (this.getStore && this.getStore.slug) || 'snappy';
                if (sid && mid) {
                  this.$router.push({ name: 'store', params: { restaurantSlug: slug, sid, mid }, query: preservedQuery }).catch(() => {});
                } else {
                  this.$router.push({ name: 'store', params: { restaurantSlug: slug, sid: sid || '' }, query: preservedQuery }).catch(() => {});
                }
                return;
              }
              // If no order or no items, go to group page
              const order = this.getServerCart || {};
              const hasOrder = order && order.subOrderList && order.subOrderList.length > 0 && order.subOrderList[0].orderItemList && order.subOrderList[0].orderItemList.length > 0;
              if (!hasOrder) {
                // Route to group page
                const groupSlug = 'snappy';
                const gid = this.getStore && this.getStore.groupId ? this.getStore.groupId : (this.$route.params.gid || '');
                this.$router.push({ name: 'group', params: { groupSlug, gid }, query: preservedQuery }).catch(() => {});
                return;
              }
              let slug = (this.getStore && this.getStore.slug) || undefined;
              let sid = (this.getStore && this.getStore.storeId) || undefined;
              let mid = (this.getMenu && this.getMenu.code) || undefined;
              if (!sid && order.storeId) sid = order.storeId;
              if (!slug && order.storeSlug) slug = order.storeSlug;
              if (!mid) {
                if (order.menuCode) {
                  mid = order.menuCode;
                } else if (order.subOrderList && order.subOrderList.length > 0) {
                  const firstSubOrder = order.subOrderList[0];
                  if (firstSubOrder.orderItemList && firstSubOrder.orderItemList.length > 0) {
                    const firstItemCode = firstSubOrder.orderItemList[0].code;
                    const match = firstItemCode && firstItemCode.match(/^(menu_\d+)/);
                    if (match && match[1]) {
                      const candidateMenuCode = match[1];
                      if (this.getAvailableMenus && Array.isArray(this.getAvailableMenus)) {
                        const foundMenu = this.getAvailableMenus.find(m => m.code === candidateMenuCode);
                        if (foundMenu) {
                          mid = candidateMenuCode;
                        }
                      }
                    }
                  }
                }
              }
              slug = slug || 'snappy';
              const params = { restaurantSlug: slug };
              if (sid) params.sid = sid;
              if (mid) params.mid = mid;
              this.$router.push({ name: 'store', params, query: preservedQuery }).catch(() => {});
            } else if (this.$route.name === 'store-account') {
              this.$router.back();
            } else {
                destinationName = this.backButtonMap[name];
              if (name === 'store') {
                if (this.filteredMenus.length > 1 || dineInOnlyQueryParam) {
                  destinationName = 'menu-selection';
                } else {
                  destinationName = 'group';
                }
              }
              if (destinationName == 'group') {
                if (dineInOnlyQueryParam) {
                  destinationName = 'store';
                } else {
                  this.$router.push({ name: destinationName, params: {groupSlug: this.getGroup.slug, gid: this.getStore.groupId}, query: preservedQuery }).catch(() => {});
                }
              } else {
                const slug = this.getStore.slug;
                this.$router.push({ name: destinationName, query: preservedQuery, params: { restaurantSlug: slug || '' } }).catch(() => {});
              }
            }
          }
        }
      },
      showBackButton() {
        const { name } = this.$route
        if (this.backButtonMap.hasOwnProperty(name)) {
          if (name === 'menu-selection') {
            return false;
          } else {
            return true;
          }
        } else {
          return false
        }
      },

      goToGuestHistory() {
        const { query } = this.$route
        const mid = (this.getMenu && this.getMenu.code) ? this.getMenu.code : undefined;
        const route = {
          name: 'guest-history',
          params: {
            sid: this.getStore.storeId,
            gid: this.getStore.groupId
          },
          query: { ...query }
        };
        if (mid) route.params.mid = mid;
        this.$router.push(route).catch(() => {})
      },

      ...mapMutations([ 'SET_CALL_SERVER_DIALOG', 'setLoginDialog' ]),
      ...mapActions([ 'setQrScanner', 'changeLang', 'fetchLiteMenus' ])
    }
  }
</script>

<style>
  .language-item {
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    border-radius: 4px;
  }

  .language-item:hover {
    background-color: #f0f0f0;
  }

  .language-item.active-lang {
    font-weight: bold;
    color: var(--v-secondary-base);
  }

  .language-item.active-lang:hover {
    background-color: #e3f2fd; 
  }
  #headerBar {
    position: fixed;
    transform: translateZ(0);
    width: 100%;
    top: 0;
    left: 0;
    height: 64px !important;
    border-radius: 0px !important;
    z-index: 99;
   }
  #app {
    padding-top: 49px;
  }
  .langSelector {
    display: inline;
    margin-right: 3px;
  }
  .langSelector:not(:last-child) {
    border-right: 2px solid rgba(240, 240, 240, 0.75);
  }

  .active-lang {
    font-weight: 600;
  }

  #openAppButton {
    min-width: 25px;
    height: 25px;
    padding: 5px;
  }

  #subHeader {
    margin-top: -64px;
  }

  #headerBar .v-toolbar__content {
    height: 64px !important;
    /* Vuetify's default is 0 24px; reservation's shared header (.hdr-inner) uses
       0 18px -- match it so the header's left/right inset lines up between apps. */
    padding: 0 18px !important;
    /* isMobile (below) OR's a viewport check with a UA sniff, so "request desktop
       site" on a phone can land on the desktop nav (7+ items: Location, Order,
       Reservations, Waitlist, Gift Cards, Add Funds, language) at phone width --
       nothing constrained that row's actual available space, so items just
       overflowed into each other (ORDER/RESERVATIONS overlapping). Let the row
       scroll horizontally instead of clipping/overlapping when that happens; at
       any width wide enough to fit everything this is a no-op (nothing to scroll). */
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap !important;
  }
  #headerBar .v-toolbar__content > * {
    flex-shrink: 0;
  }


  .cartDialogClass.v-dialog .v-toolbar .v-toolbar__content>div ,
  .cartDialogClass.v-dialog .v-toolbar .v-btn__content {
    font-size: 18px !important;
    text-transform: none;
  }

  .cartDialogClass.v-dialog .v-toolbar .v-toolbar__content {
    height: 64px !important;
  }

  .cartDialogClass.v-dialog {
    overflow-y: hidden !important;
    border-radius: 16px !important;
    background: var(--v-primary-base) !important;

  }
  @media all and (max-width: 959px) {
    .cartDialogClass.v-dialog {
      border-radius: 0px !important;
    }
  }
  @media all and (min-width: 960px) {
    .cartDialogClass.v-dialog {
      position: fixed !important;
      top: 20px !important;
      right: 20px !important;
    }
  }

  #cartSizeBtn {
    margin-left: 15px;
    padding: 0px 10px !important;
    height: 42px !important;
  }
  #cartSizeBtn span {
    margin-left: 5px;

    font-size: 18px;
    text-transform: none;
  }

  /* #cartBtn {
    margin: 13px 0px 0px 0px;

    background-color: white;
    border: 1px solid white;
    border-radius: 50%;

    width: 40px;
    height: 40px;
  } */
  /* #cartSize {
    position: absolute;
    top: 0px;
    right: 10px;

    font-size: 18px;
    text-transform: none;
    color: white;
  } */

  .cart-error #cartBtn.v-btn,
  .cart-error #cartSize {
    border-color: var(--danger) !important;
    color: var(--danger) !important;
  }
  .cart-error #cartBtn {
    background-color: var(--danger) !important;
  }
  .cart-error #cartBtn.primary--text {
    color: white !important;
    caret-color: white !important;
  }
  .v-badge__badge {
    font-size: 11px !important;
    top: -7px !important;
    right: -5px !important;
    height: 15px !important;
    width: 15px !important;
  }
  .badge-text {
    color: var(--v-primary-base) !important;
    font-weight: 600 !important;
  }
</style>
<style scoped>
  /* Matches reservation's shared header (.hdr-btn): 64px-tall bar, Poppins
     14px uppercase labels, 14px horizontal padding per item -- Vuetify's
     v-btn defaults (Roboto, min-width 88px, its own padding/margin) is what
     made this look/space differently from reservation before this fix. */
  .externalAppsButton {
    height: 64px !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 0 14px !important;
    border-radius: 0 !important;
    font-family: 'Poppins', Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    letter-spacing: normal !important;
    text-transform: uppercase !important;
  }
  .externalAppsButton >>> .v-btn__content {
    color: rgba(255, 255, 255, 0.87);
  }
  .externalAppsButton:hover >>> .v-btn__content {
    color: #fff;
  }
  /* Non-clickable "you are here" label (Order) -- same convention as
     reservation's .hdr-btn-active: full-white, bold, no hover/click.
     !important needed to beat .externalAppsButton's own font-weight:500
     !important -- important rules always win over non-important ones
     regardless of selector order/specificity. */
  .externalAppsButtonActive {
    display: inline-flex;
    align-items: center;
    color: #fff !important;
    font-weight: 700 !important;
    cursor: default;
    white-space: nowrap;
  }
  /* Mobile drawer's Order row: a disabled v-btn (so it inherits the same
     bold/uppercase v-btn styling every other drawer row gets), but full
     white/opaque instead of Vuetify's dimmed disabled look -- this is a
     "you are here" label, not an inactive control. */
  .order-label-btn.v-btn--disabled {
    color: #fff !important;
    opacity: 1 !important;
  }
  .order-label-btn.v-btn--disabled >>> .v-btn__content {
    color: #fff !important;
  }
  .external-apps-drawer {
    z-index: 1000;
    width: 100vw !important;
    max-width: 100vw !important;
    background: var(--v-primary-base) !important;
    transform: translateX(-100%) !important;
  }

  .external-apps-drawer.v-navigation-drawer--open {
    transform: translateX(0) !important;
  }

  .external-apps-drawer >>> .v-navigation-drawer__content {
    width: 100vw !important;
    max-width: 100vw !important;
  }
  .v-list-item {
    height: 64px;
  }

  .close-btn {
    position: absolute !important;
    right: 16px !important;
    margin: 0 !important;
    top: 20px !important;
  }
  
  .item-text {
    font-size: 20px;
  }
  @media (max-width: 480px) {
    .v-toolbar-items .v-btn {
      min-width: 36px !important;
      padding: 0 8px !important;
      font-size: 12px !important;
    }
    
    .v-toolbar-items .v-btn span {
      font-size: 12px !important;
    }
    
    .v-toolbar-items .v-btn .v-icon {
      font-size: 18px !important;
    }
  }

  .close-btn-left {
    position: absolute !important;
    left: 16px !important;
    margin: 0 !important;
    top: 20px !important;
  }

  .menu-item {
    height: 64px;
    padding-left: 24px !important;
  }

  .menu-icon {
    margin-right: 32px !important;
  }

  .v-list-item__title {
    font-size: 16px;
    font-weight: 500;
  }

  .mobile-title{ 
    margin-left: 5px;
    font-size: 17px;
    font-weight: 900;
  }
  .mobile-list-item {
    padding: 0px 16px !important;
    margin-bottom: 0px !important;
  }
  .mobile-list-item + .mobile-list-item {
    margin-top: 8px !important;

  }

  .cartDialogClass.v-dialog {
    overflow-y: hidden !important;
    border-radius: 16px !important;
  }

  .cartDialogClass.rounded-dialog >>> .v-card {
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .rounded-card {
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .cartDialogClass >>> .v-toolbar {
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
  }

  .header-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    min-height: 64px;
  }

  @media all and (min-width: 960px) {
    .cartDialogClass.v-dialog {
      position: fixed !important;
      top: 20px !important;
      right: 20px !important;
      border-radius: 16px !important;
      overflow: hidden !important;
    }
  }

  @media (max-width: 959px) {
    .v-badge {
      margin-right: 4px;
    }
    .externalAppsButton {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .v-badge {
      margin-right: 0;
    }
  }
  @media (min-width: 600px) and (max-width: 959px) {
    .cartDialogClass.v-dialog {
      max-width: 90% !important;
      margin: 0 auto !important;
    }
  }
  .cartDialogClass.rounded-dialog >>> .v-card {
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .rounded-card {
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .cartDialogClass >>> .v-toolbar {
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
  }

  .header-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    min-height: 64px;
  }

  @media all and (min-width: 960px) {
    .cartDialogClass.v-dialog {
      position: fixed !important;
      top: 20px !important;
      right: 20px !important;
      border-radius: 16px !important;
      overflow: hidden !important;
    }
  }

  @media (max-width: 959px) {
    .v-badge {
      margin-right: 4px;
    }
    .externalAppsButton {
      display: none !important;
    }
  }
  @media (max-width: 959px) {
    .v-badge {
      margin-right: 0;
    }
  }
  @media (min-width: 600px) and (max-width: 959px) {
    .cartDialogClass.v-dialog {
      max-width: 90% !important;
      margin: 0 auto !important;
    }
  }

  .mobile-cart-container {
    display: flex;
    align-items: center;
    padding: 0 8px;
    min-width: 48px;
    justify-content: center;
  }

  @media (max-width: 480px) {
    .mobile-cart-container {
      padding: 0 2px;
      min-width: 36px;
    }
    
    .v-toolbar-items {
      margin-left: auto;
    }
    
    .v-toolbar .v-btn {
      min-width: 36px !important;
      padding: 0 4px !important;
    }
    
    .v-toolbar .v-btn--icon {
      width: 36px !important;
      height: 36px !important;
    }
  }
</style>